import type { RoleConfig } from '../types.js';

export const sheriff: RoleConfig = {
  id: 'sheriff',
  faction: 'town',
  title: { ru: 'Шериф', uk: 'Шериф' },
  latin: 'SHERIFF',
  number: '02',
  accent: '#2fd6c2',
  sub: '#a8b8b6',
  ability: {
    ru: 'Ночью проверяет одного игрока на принадлежность к мафии.',
    uk: 'Вночі перевіряє одного гравця на належність до мафії.',
  },
  abilities: [
    {
      key: 'check',
      phase: 'night',
      cadence: 'every-night',
      canSelfTarget: false,
    },
  ],
  victory: { type: 'town' },
};
